export const SendMessage = (message) => {
    if(window.CefSharp){
        console.log("CefSharp exists, sending", message);
        window.CefSharp.PostMessage(message);
    }
    else{
        console.log("CefSharp not available.");
    }
}